import { KrLogo } from './logos/kr'
import { SquareMeterChart } from './SquareMeterChart'
import React from 'react'
import { ContextStats } from './fetchContextStats'
import { Card } from '@warp-ds/react'
import { Tooltip } from './tooltip'

interface SquareMeterProps {
    contextStats: ContextStats
    isMobile: boolean
    redirectUrl: string
}

export const SquareMeterCard = ({
    contextStats,
    isMobile,
    redirectUrl
}: SquareMeterProps) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                marginLeft: '0px'
            }}
        >
            <Card
                className="wfull podletcard"
                onClick={() => {
                    window.location.href = redirectUrl
                }}
            >
                <div
                    style={{
                        height: '94px',
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: 'white',
                        padding: '14px 14px 0px'
                    }}
                >
                    <div className="cardHeadText">
                        Pris per kvadratmeter (m²)
                    </div>
                    <Tooltip id={'sqm-price'}>
                        <div
                            style={{ maxWidth: '400px' }}
                            className="bg-white shadow rounded-8 overflow-hidden"
                        >
                            <div className="px-16 py-16">
                                <span className="text-16 font-bold">
                                    {'Kvadratmeterpris'}
                                </span>
                                <p className="text-14 text-gray-700 mt-8">
                                    {
                                        'For å finne gjennomsnittlig kvadratmeterpris for boliger i det aktuelle området tar vi utgangspunkt i prisantydning (inkludert eventuell fellesgjeld) for valgte boligtyper. Deretter beregner vi et gjennomsnitt basert på boligenes primærrom. Vær obs på at kvadratmeterpris basert på prisantydning ikke nødvendigvis reflekterer prisene som boligene faktisk selges for.'
                                    }
                                </p>
                            </div>
                        </div>
                    </Tooltip>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}
                    >
                        <KrLogo />
                        <div style={{ marginLeft: '8px', fontSize: '22px' }}>
                            {new Intl.NumberFormat('fr-FR').format(
                                contextStats.data.squareMeterPriceAvgLast30Days
                            )}{' '}
                            kr
                        </div>
                    </div>
                    <div>i snitt per annonse siste 30 dager</div>
                </div>
                <div>
                    <SquareMeterChart
                        stats={contextStats.data.squareMeterPriceHist}
                        isMobile={isMobile}
                    />
                </div>
            </Card>
        </div>
    )
}
